import taxItemGroupHeadingServiceGen from "./generated/taxItemGroupHeadingServiceGen";

class taxItemGroupHeadingService extends taxItemGroupHeadingServiceGen {
}

export default taxItemGroupHeadingService;